import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FooterLink, FooterText } from './FormComponents';
export default function TermsAndPrivacyMessage(param) {
    let { type } = param;
    return /*#__PURE__*/ _jsxs("div", {
        style: {
            textAlign: 'center'
        },
        children: [
            /*#__PURE__*/ _jsx(FooterText, {
                children: "By signing ".concat(type === 'login' ? 'in' : 'up', " to Anchor, you agree to our ")
            }),
            /*#__PURE__*/ _jsx(FooterLink, {
                toExternalLink: "https://www.sayanchor.com/terms-of-contact",
                target: "_blank",
                children: "Terms of Service"
            }),
            /*#__PURE__*/ _jsx(FooterText, {
                children: " and "
            }),
            /*#__PURE__*/ _jsx(FooterLink, {
                toExternalLink: "https://www.sayanchor.com/privacy-policy",
                target: "_blank",
                children: "Privacy policy"
            }),
            /*#__PURE__*/ _jsx(FooterText, {
                children: "."
            })
        ]
    });
}
